import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from "react";
import { Modal, ModalOverlay, ModalContent, useDisclosure } from "@chakra-ui/react";
var ModalTrigger = function(param) {
    var trigger = param.trigger, children = param.children, modalProps = param.modalProps;
    var ref = useDisclosure(), isOpen = ref.isOpen, openModal = ref.onOpen, closeModal = ref.onClose;
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            trigger(openModal),
            /*#__PURE__*/ _jsx(Modal, _object_spread_props(_object_spread({
                isOpen: isOpen,
                onClose: closeModal,
                preserveScrollBarGap: true
            }, modalProps), {
                children: /*#__PURE__*/ _jsx(ModalOverlay, {
                    children: /*#__PURE__*/ _jsx(ModalContent, {
                        children: children(closeModal)
                    })
                })
            }))
        ]
    });
};
export default ModalTrigger;
